import { MAIN_APP_API_URL, MAIN_APP_URL } from '@/types';

/** Files served by the main site (www), not by the API. */
function isMainSiteAsset(path: string): boolean {
  const p = path.replace(/^\/+/, '').split('?')[0].toLowerCase();
  return (
    p.startsWith('home_background/') ||
    p.startsWith('logo_background/') ||
    p === 'hkhbref_logo.png' ||
    p.startsWith('hkhbref_logo.') ||
    p.startsWith('icon-') ||
    p.startsWith('favicon') ||
    p === 'icon.svg'
  );
}

/** Resolve Cloudinary or server-relative photo paths (same logic as main hkhbref frontend). */
export function getPhotoUrl(photoPath: string | null | undefined): string | null {
  if (!photoPath) return null;

  if (photoPath.startsWith('http://') || photoPath.startsWith('https://')) {
    if (photoPath.includes('cloudinary.com') && photoPath.includes('/image/upload/')) {
      const uploadMatch = photoPath.match(/\/image\/upload\/([^/]+)\//);
      if (uploadMatch) {
        const afterUpload = uploadMatch[1];
        const isVersion = /^v\d+$/.test(afterUpload);
        const hasTransformations = /[a-z_,\-]/.test(afterUpload);
        if (isVersion || !hasTransformations) {
          return photoPath.replace('/image/upload/', '/image/upload/f_auto,q_auto/');
        }
      } else {
        return photoPath.replace('/image/upload/', '/image/upload/f_auto,q_auto/');
      }
    }
    return photoPath;
  }

  const trimmed = photoPath.replace(/^\/+/, '');
  if (isMainSiteAsset(trimmed)) {
    const path = photoPath.startsWith('/') ? photoPath : `/${photoPath}`;
    return `${MAIN_APP_URL.replace(/\/$/, '')}${path}`;
  }
  const relative = trimmed.startsWith('api/') ? trimmed : `api/${trimmed}`;
  if (MAIN_APP_API_URL.startsWith('http')) {
    const base = MAIN_APP_API_URL.replace(/\/api\/?$/, '');
    return `${base}/${relative}`;
  }
  const prefix = MAIN_APP_API_URL.replace(/\/$/, '') || '/main-api';
  return `${prefix}/${relative}`;
}

export async function fetchMainAppLoginLogo(): Promise<string | null> {
  try {
    const res = await fetch(`${MAIN_APP_API_URL}/admin/login-settings`, {
      credentials: 'omit',
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { logo_url?: string | null };
    return getPhotoUrl(data.logo_url ?? null);
  } catch {
    return null;
  }
}
